import { useState } from "react";

import { LoadingState } from "@/components/loading-state";
import { Panel } from "@/components/panel";
import { QueryErrorState } from "@/components/query-error-state";
import { asCurrency, formatNumber, pickNumber, pickString } from "@/lib/format";
import { asRecord } from "@/lib/type-utils";
import { useMarketDetail } from "@/sdk/hooks/use-market-data";

export function DecoderPanel() {
  const [marketId, setMarketId] = useState("");
  const [queried, setQueried] = useState<string | null>(null);
  const detail = useMarketDetail(queried);
  const payload = asRecord(detail.data);

  const question = pickString(payload, ["question", "title"]);
  const description = pickString(payload, ["description", "subtitle"]);
  const yesPrice = pickNumber(payload, ["yes_price", "best_bid", "best_ask"]);
  const noPrice = pickNumber(payload, ["no_price"]);
  const volume = pickNumber(payload, ["volume_24h", "volume", "liquidity"]);

  return (
    <Panel title="Market Decoder">
      <div className="space-y-3">
        <div className="flex gap-2">
          <input
            className="flex-1 rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm text-white placeholder-white/30 focus:outline-none"
            placeholder="Market ID..."
            value={marketId}
            onChange={(event) => setMarketId(event.target.value)}
          />
          <button
            type="button"
            onClick={() => setQueried(marketId.trim() || null)}
            className="rounded bg-blue-600 px-3 py-1.5 text-xs text-white hover:bg-blue-500"
          >
            Decode
          </button>
        </div>

        {detail.isLoading && <LoadingState text="Decoding..." />}

        {detail.isError ? (
          <QueryErrorState what="market detail" onRetry={() => void detail.refetch()} />
        ) : payload && Object.keys(payload).length > 0 ? (
          <div className="space-y-2">
            <p className="text-sm text-white/80">{question ?? queried}</p>
            {description ? (
              <p className="text-xs leading-relaxed text-white/50">{description}</p>
            ) : null}
            <div className="flex flex-wrap gap-4 text-xs text-white/40">
              <span>YES: {yesPrice == null ? "?" : `${Math.round(yesPrice * 100)}%`}</span>
              <span>NO: {noPrice == null ? "?" : `${Math.round(noPrice * 100)}%`}</span>
              <span>Volume: {volume == null ? "?" : asCurrency(volume)}</span>
              <span>Liquidity: {formatNumber(pickNumber(payload, ["liquidity", "liquidity_usd"]))}</span>
            </div>
          </div>
        ) : null}
      </div>
    </Panel>
  );
}
